'use strict';

const _ = require('underscore');
const Moment = require('moment');
const Backbone = require('backbone');
const IdeaStateFactory = require('../factory/idea-state');
const UserRequestCommentCollection = require('../collection/comment');

module.exports = Backbone.Model.extend({
    /**
     * Backbone.Model を extend した UserRequestModel を定義する
     */
    defaults: {
        title: '',
        body: '',
        status: 'new',
        request_user: null
    },

    validation: {
        title: [
            {
                required: true,
                msg: 'input.user_request.title.validation.required'
            }
        ],
        body: [
            {
                required: true,
                msg: 'input.user_request.body.validation.required'
            }
        ]
    },

    initialize: function() {
        this.comments = new UserRequestCommentCollection();
        this.listenTo(this, 'all', this._updateComments);
        this._updateComments();

        this.listenTo(this, 'change:state', this._updateState);
        this._updateState();
        _.bindAll(this, '_updateComments');
    },

    _updateState: function() {
        this.set('_state', IdeaStateFactory.build(this.get('state')));
    },

    idParams: function() {
        return {
            user_request_id: this.get('id')
        };
    },

    editableAttributes: function() {
        const json = this.toJSON();
        delete json['id'];
        return json;
    },

    getTitle: function() {
        return this.get('title');
    },

    getBody: function() {
        return this.get('body');
    },

    getState: function() {
        return this.get('_state');
    },

    getEstimate: function() {
        return this.get('estimate');
    },

    getEstimateChoices: function() {
        return this.get('estimateChoices');
    },

    getCommentCount: function() {
        return this.get('commentCount');
    },

    getUpdatedAt: function() {
        return Moment(this.get('updatedAt'));
    },

    getCreatedAt: function() {
        return Moment(this.get('createdAt'));
    },

    getRelatedURLs: function() {
        return this.get('relatedURLs');
    },

    getSummary: function() {
        return this.get('summary');
    },

    isPublic: function() {
        return this.get('public')
    },

    isPrivate: function() {
        return !this.isPublic()
    },

    getRequestUserID: function() {
        return this.get('request_user') && this.get('request_user').id;
    },

    _updateComments: function() {
        this.comments.reset(this.get('comments'));
        this.comments.user_request_id = this.get('id');
    }
});




// WEBPACK FOOTER //
// ./feedback/domain/entity/idea.js